import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  ViewChildren,
  QueryList,
  AfterViewInit,
  PLATFORM_ID,
  Inject,
  ChangeDetectorRef,

} from '@angular/core';
import { register } from 'swiper/element/bundle';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CommonModule, isPlatformBrowser, DOCUMENT } from '@angular/common';
register();
import { Title, Meta } from '@angular/platform-browser';
import { ApiCallService } from '../../Services/ApiCallService';

export interface TreatmentItemModel {
  TreatmentItemID: number;
  TreatmentName: string;
  MainCategory: string | null;
  Description: string | null;
  Benefits: string | null;
  Price: number;
  CityID: number | null;
  Image: string | null;
  IsActive?: number | boolean;
}

export interface TMContent {
  ContentID: number;
  SectionKey: string;
  Eyebrow: string | null;
  Title: string | null;
  SubTitle: string | null;
  Description: string | null;
  Image: string | null;
  ImagePosition: string | null;   // 'Left' | 'Right' (custom sections)
}
export interface TMBenefit {
  BenefitID: number;
  IconKey: string;
  Title: string;
  Description: string;
  SortOrder: number;
}
export interface FaqItem {
  FAQID: number;
  QuestionNo: number | null;
  Question: string;
  Answer: string;
  IsActive: boolean;
  Category: string;
}

@Component({
  selector: 'app-timelessmonk',
  standalone: true,
  imports: [CommonModule, HttpClientModule],
  templateUrl: './timelessmonk.html',
  styleUrl: './timelessmonk.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  host: { ngSkipHydration: 'true' },
})
export class Timelessmonk implements AfterViewInit {
  @ViewChildren('swiper')
  swiperRefs!: QueryList<ElementRef>;

  categoryGroups: any[] = [];
  loading = true;
  errorMessage = '';
  content: { [key: string]: TMContent } = {};
  benefits: TMBenefit[] = [];

  customSections: TMContent[] = [];   // sections added from the dashboard (SectionKey starts with CUSTOM_)

  imageBaseUrl = 'https://crm-api.redmonkwellness.com';
  apiUrl = 'https://crm-api.redmonkwellness.com/Treatment/GetTreatment';

  //FAQ-----
  faqs: FaqItem[] = [];
  faqLoading = false;
  faqError = '';   // friendly message shown to visitors

  private readonly FAQ_CATEGORY = 'BeautyIVTherapy';   // must match the dashboard exactly
  private readonly FAQ_API = 'https://crm-api.redmonkwellness.com/api/IVTherapyBenefits/GetActiveFAQ';


  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private title: Title,
    private meta: Meta,
    private api: ApiCallService,
    @Inject(DOCUMENT) private document: Document
  ) { }


  ngOnInit(): void {

    this.setSeo();
    this.loadItems();
    this.loadPageData();
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.loadTreatments();
    this.loadFaqs();
  }


  loadFaqs(): void {
    this.faqLoading = true;
    this.faqError = '';

    this.http.get<any>(this.FAQ_API, { params: { category: this.FAQ_CATEGORY } }).subscribe({
      next: (res) => {
        const list = (res?.Success ?? res?.success) ? (res.Data || res.data || []) : null;

        if (list === null) {
          this.faqError = 'We could not load the questions right now. Please try again in a moment.';
          this.faqs = [];
        } else {
          this.faqs = list;   // the API already filters active rows and sorts them
        }
        this.faqLoading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('FAQ load failed:', err);   // technical details go to the console only
        this.faqs = [];
        this.faqError = err?.status === 0
          ? 'We could not connect to the server. Please check your internet connection and try again.'
          : 'Something went wrong while loading the questions. Please try again in a moment.';
        this.faqLoading = false;
        this.cdr.detectChanges();
      },
    });
  }

  pad(n: number): string {
    return n < 10 ? '0' + n : String(n);
  }
  beautyItems: TreatmentItemModel[] = [];
  loadingItems = false;
  failedImages = new Set<string>();
  private readonly BEAUTY_CATEGORY = 'Beauty I.V. Therapy';

  loadItems(): void {
    if (this.loadingItems) return;
    this.loadingItems = true;

    this.api.postData('Calendar', 'GetAllTreatmentItems', {}).subscribe({
      next: (res: any) => {
        this.loadingItems = false;
        if (!res?.Success) return;

        const items = (res.TreatmentItems || []) as TreatmentItemModel[];
        this.beautyItems = this.pickByCategory(items, this.BEAUTY_CATEGORY);
      },
      error: (err) => {
        this.loadingItems = false;
        console.error(err);
      },
    });
  }

  private pickByCategory(items: TreatmentItemModel[], category: string): TreatmentItemModel[] {
    const seen = new Set<string>();
    return items
      .filter((i) => (i.MainCategory || '').trim().toLowerCase() === category.toLowerCase() &&
        Number(i.IsActive ?? 0) === 0)
      .sort((a, b) => a.TreatmentItemID - b.TreatmentItemID)
      .filter((i) => {
        const key = (i.TreatmentName || '').trim().toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  }

  trackByItemId(_: number, p: TreatmentItemModel): number {
    return p.TreatmentItemID;
  }

  imgUrl(path: string | null | undefined): string {
    if (!path) return '';
    if (/^https?:\/\//i.test(path) || path.startsWith('data:')) return path;
    return this.imageBaseUrl.replace(/\/+$/, '') + '/' + path.replace(/^\/+/, '');
  }

  onImgError(key: string): void {
    this.failedImages.add(key);
  }
  loadTreatments(): void {
    this.http.post<any>(this.apiUrl, {}).subscribe({
      next: (res) => {
        // if (res.success) {
        //   this.categoryGroups = this.groupByCategory(res.TreatmentHistory || []);
        // } 
        if (res.success) {
          const list = (res.TreatmentHistory || []).filter(
            (t: any) =>
              Number(t.IsActive) === 0 &&
              (t.TreatmentType || '').trim().toLowerCase() === 'procedure'
          );
          this.categoryGroups = this.groupByCategory(list);
        }
        else {
          this.errorMessage = res.message || 'Unable to load treatments.';
        }
        this.loading = false;
        this.cdr.detectChanges(); // force render in case this ran outside Angular's zone

        // Initialize swipers after data is loaded and DOM is updated
        setTimeout(() => this.initSwipers(), 100);
      },
      error: (err) => {
        console.error(err);
        this.errorMessage = 'Unable to load treatments. Please try again later.';
        this.loading = false;
        this.cdr.detectChanges();
      },
    });
  }

  groupByCategory(list: any[]): any[] {
    const map = new Map<string, any[]>();
    for (const t of list) {
      const key = t.Category || 'Other';
      if (!map.has(key)) map.set(key, []);
      map.get(key)!.push(t);
    }
    return Array.from(map.entries()).map(([category, treatments]) => ({
      category,
      treatments,
      loop: treatments.length > 3,
    }));
  }

  trackById(_index: number, item: any): number {
    return item.ID;
  }

  setDefaultImage(event: Event): void {
    const element = event.target as HTMLImageElement;
    element.src = '/assets/images/treatments/no-image.jpg';
  }

  // TimelessMonk Contents

  // ===== 4. ADD methods (inside the class) =====
  loadPageData(): void {
    this.api.postData('TimelessMonk', 'GetPageData', {}).subscribe({
      next: (res: any) => {
        if (!(res?.success ?? res?.Success)) return;
        const map: { [key: string]: TMContent } = {};
        (res.Content || []).forEach((c: TMContent) => (map[c.SectionKey] = c));
        this.content = map;
        this.benefits = res.Benefits || [];
        this.customSections = (res.Content || []).filter((c: TMContent) => (c.SectionKey || '').indexOf('CUSTOM_') === 0);
        this.cdr.detectChanges();
      },
      error: (err) => console.error(err),
    });
  }

  // split description into paragraphs (blank line = new paragraph)
  paragraphs(text: string | null | undefined): string[] {
    return (text || '').split(/\r?\n\s*\r?\n/).map(p => p.trim()).filter(p => p);
  }

  // "IV Therapy Benefits" -> { main: "IV Therapy", accent: "Benefits" }
  splitLast(text: string | null | undefined): { main: string; accent: string } {
    const t = (text || '').trim();
    const i = t.lastIndexOf(' ');
    return i < 0 ? { main: '', accent: t } : { main: t.substring(0, i), accent: t.substring(i + 1) };
  }

  // assets images stay as-is, uploaded/API images get the API base url
  contentImg(path: string | null | undefined): string {
    if (!path) return '';
    return path.startsWith('/assets') ? path : this.imgUrl(path);
  }


  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // Initialize swipers on first load if data is already present
    if (this.categoryGroups.length > 0) {
      setTimeout(() => this.initSwipers(), 100);
    }

    // Also watch for changes to ViewChildren
    this.swiperRefs.changes.subscribe(() => this.initSwipers());
  }

  private initSwipers(): void {
    import('swiper/element/bundle').then(({ register }) => {
      register();

      this.swiperRefs.forEach((swiperRef) => {
        const swiperEl: any = swiperRef.nativeElement;
        if (swiperEl.swiper) return;

        const shouldLoop = swiperEl.getAttribute('data-loop') === 'true';
        const catIndex = swiperEl.getAttribute('data-index');

        Object.assign(swiperEl, {
          loop: shouldLoop,
          speed: 1000,
          spaceBetween: 20,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          navigation: {
            prevEl: `.custom-prev-${catIndex}`,
            nextEl: `.custom-next-${catIndex}`,
          },
          pagination: false,
          breakpoints: {
            0: { slidesPerView: 1 },
            576: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
            1200: { slidesPerView: 3 },
          },
        });

        swiperEl.initialize();
      });
    });
  }


private setSeo(): void {
  const pageTitle =
    'Beauty IV Therapy in Mumbai | Cosmetic IV Drips | Red Monk Wellness';

  const description =
    'Beauty IV Therapy at Red Monk Wellness with cosmetic IV drips designed around individual beauty and wellness goals.';

  const keywords =
    'Beauty IV Therapy Mumbai, cosmetic IV therapy Mumbai, cosmetic IV drips Mumbai, beauty IV drips Mumbai, anti ageing IV therapy Mumbai, IV therapy for skin glow Mumbai, hydration IV drip Mumbai, skin glow IV drip Mumbai, immunity IV drip Mumbai, energy IV drip Mumbai, Red Monk Wellness, Timeless Monk';

  const canonicalUrl =
    'https://www.redmonkwellness.com/timelessmonk';

  const ogImage =
    'https://www.redmonkwellness.com/assets/images/banner/banner1.jpeg';

  // TITLE
  this.title.setTitle(pageTitle);

  // BASIC META
  this.meta.updateTag({
    name: 'description',
    content: description
  });

  this.meta.updateTag({
    name: 'keywords',
    content: keywords
  });

  this.meta.updateTag({
    name: 'robots',
    content:
      'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
  });

  // OPEN GRAPH
  this.meta.updateTag({
    property: 'og:type',
    content: 'website'
  });

  this.meta.updateTag({
    property: 'og:locale',
    content: 'en_IN'
  });

  this.meta.updateTag({
    property: 'og:site_name',
    content: 'Red Monk Wellness'
  });

  this.meta.updateTag({
    property: 'og:title',
    content: pageTitle
  });

  this.meta.updateTag({
    property: 'og:description',
    content:
      'Explore Beauty IV Therapy in Mumbai at Red Monk Wellness, with cosmetic IV drips designed for skin glow, hydration, energy, recovery and overall wellness.'
  });

  this.meta.updateTag({
    property: 'og:url',
    content: canonicalUrl
  });

  this.meta.updateTag({
    property: 'og:image',
    content: ogImage
  });

  this.meta.updateTag({
    property: 'og:image:alt',
    content: 'Beauty IV Therapy at Red Monk Wellness'
  });

  this.meta.updateTag({
    property: 'og:image:type',
    content: 'image/jpeg'
  });

  // TWITTER / X
  this.meta.updateTag({
    name: 'twitter:card',
    content: 'summary_large_image'
  });

  this.meta.updateTag({
    name: 'twitter:title',
    content: pageTitle
  });

  this.meta.updateTag({
    name: 'twitter:description',
    content:
      'Explore Beauty IV Therapy in Mumbai at Red Monk Wellness, with cosmetic IV drips designed for skin glow, hydration, energy, recovery and overall wellness.'
  });

  this.meta.updateTag({
    name: 'twitter:image',
    content: ogImage
  });

  this.meta.updateTag({
    name: 'twitter:image:alt',
    content: 'Beauty IV Therapy at Red Monk Wellness'
  });

  // CANONICAL URL
  let canonical = this.document.querySelector(
    'link[rel="canonical"]'
  ) as HTMLLinkElement | null;

  if (!canonical) {
    canonical = this.document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    this.document.head.appendChild(canonical);
  }

  canonical.setAttribute('href', canonicalUrl);

  // SITEMAP
  let sitemap = this.document.querySelector(
    'link[rel="sitemap"]'
  ) as HTMLLinkElement | null;

  if (!sitemap) {
    sitemap = this.document.createElement('link');
    sitemap.setAttribute('rel', 'sitemap');
    sitemap.setAttribute('type', 'application/xml');
    sitemap.setAttribute('title', 'Sitemap');
    this.document.head.appendChild(sitemap);
  }

  sitemap.setAttribute(
    'href',
    'https://www.redmonkwellness.com/sitemap.xml'
  );
}



}
